import { Component } from '@angular/core';
import { PagesService } from '@app/_services/pages.service';
import {PublicationsService} from "@app/_services/publications.service";

import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';

@Component({
  selector: 'jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent {

  entries: any[]
  rootEntries: any
  news: any[] =[]

  constructor(
    private pagesService: PagesService,
    private publicationsService: PublicationsService,
    private http: HttpClient,
  ){}

  get currentPage(){
    return this.pagesService.currentPage
  }

  get pictURL() {
   return this.currentPage?.picture?.data.links.open;
  }

  get isRootPage(){
    return !this.pagesService.currentPage?.parents.data.length && this.pagesService.currentPage
  }

  newlist(type: string, params?: {}) {
    return this.http.get(`${environment.apiUrl}/api/registries/list/${type}`, {params: params});
  }

  ngOnInit(){

    


    let include = ['registry.page', 'properties.groups.fields.value'];
    this.newlist('notice',{include: include.join(',')}).subscribe(
      (resp:any)=>{
        this.rootEntries = resp.data;

        this.newlist('approval',{include: include.join(',')}).subscribe(
          (resp:any)=>{

            this.rootEntries = this.rootEntries
            .concat(resp.data)
            .sort((a,b)=> a.createdAt<b.createdAt?1:-1)
            .slice(0,5)

            this.entries = this.rootEntries.map(entry=>{

              let properties = entry.properties.data.groups.data[0].fields.data;
              let findProp = (propName)=>properties.find(prop=>prop.name==propName)?.value.data[0]

              return{
                type: entry.registry.data.type.title,
                page: entry.registry.data.page.data.link,
                name: entry.name,
                notificationDate: findProp('notification-date'),
                subcommittee: findProp('subcommittee'),
                startDiscussion: findProp('start-discussion'),
                endDiscussion: findProp('end-discussion'),
                yearInclusion: findProp('year-inclusion'),
                documentType: findProp('document-type'),
                designation: findProp('designation'),
                order: findProp('order'),
              }
            })
          }
        )
      }
    );

    this.publicationsService.list({subType: 'publication-news'}).subscribe(resp=>{

      this.news = resp.data.slice(0,5).map( pub =>
        ({
          name: pub.name,
          date: pub.publishDateRus,
          link: pub.link     
        }))
    })
  }


}
